var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_windows)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29082 1.55481L0.290821 2.33415C0.12354 2.35574 -0.00124168 2.49884 0.000133324 2.66749V7.33415C0.000133324 7.51824 0.149383 7.66749 0.333477 7.66749H6.33348C6.51757 7.66749 6.66682 7.51824 6.66682 7.33415V1.88481C6.6667 1.78906 6.62542 1.69799 6.55348 1.63481C6.48101 1.57249 6.38573 1.54346 6.29082 1.55481Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8868 0.417464C15.8154 0.353089 15.7197 0.322714 15.6242 0.33412L7.62416 1.37746C7.45691 1.39906 7.3321 1.54215 7.33351 1.71081V7.33415C7.33351 7.51825 7.48276 7.66749 7.66685 7.66749H15.6669C15.851 7.66749 16.0002 7.51825 16.0002 7.33415V0.667464C16.0001 0.571714 15.9587 0.480651 15.8868 0.417464Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33348 8.33416H0.333477C0.149383 8.33416 0.000133324 8.48341 0.000133324 8.6675V13.3342C-0.00124168 13.5028 0.12354 13.6459 0.29079 13.6675L6.29079 14.4502C6.30501 14.4511 6.31926 14.4511 6.33345 14.4502C6.51754 14.4502 6.66679 14.3009 6.66679 14.1168V8.6675C6.66682 8.48341 6.51757 8.33416 6.33348 8.33416Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 8.33416H7.66673C7.48264 8.33416 7.33339 8.48341 7.33339 8.6675V14.2908C7.33201 14.4595 7.45679 14.6026 7.62404 14.6242L15.624 15.6675C15.6383 15.6685 15.6525 15.6685 15.6667 15.6675C15.8508 15.6675 16 15.5183 16 15.3342V8.6675C16 8.48341 15.8508 8.33416 15.6667 8.33416Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_windows"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsWindows);
export default __webpack_public_path__ + "static/media/os-windows.39006a2eadd5315b5f8f9d669778c463.svg";
export { ForwardRef as ReactComponent };